import React, { useCallback, useEffect } from "react";
import { producaov2 as api } from "../../../../../../services/apis";
import { SemanticTable } from "./styled";
import { Button, Dimmer, Icon, Loader, Modal } from "semantic-ui-react";
import swal from "sweetalert";

const ScrollingModal = (parceiro) => {
  const [open, setOpen] = React.useState(false);
  const [load, setLoad] = React.useState();
  const [parceiroSolicitacao, setParceiroSolicitacao] = React.useState();
  const [andamento, setAndamento] = React.useState();

  const loadData = async () => {
    try {
      setLoad(true);

      const params = { page: 1, search: parceiro.parceiro };

      const response = await api.get("/pb4y-listagem-solicitacoes-parceiros", {
        params,
      });
      const { solicitacoesParceiros, count } = response.data;
      setParceiroSolicitacao(solicitacoesParceiros[0]);
      setLoad(false);
    } catch (err) {
      setLoad(false);
      console.error(err);
      swal("Não foi possível os dados desta solicitacao", "", "");
    }
  };

  const saveData = async () => {
    try {
      const params = {
        nome: parceiro.parceiro,
        status: andamento,
      };

      await api.put(`/pb4y-atualizar-solicitacao-parceiro`, {
        params,
      });

      swal("Andamento atualizado com sucesso!", "", "");
    } catch (err) {
      console.error(err);
      swal(
        "Não foi possível atualizar o andamento, tente novamente mais tarde",
        "",
        ""
      );
    }
  };

  return (
    <Modal
      open={open}
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      trigger={<Button onClick={loadData}>Editar andamento</Button>}
    >
      <Modal.Header>{parceiro.parceiro}</Modal.Header>
      {load && (
        <Dimmer active>
          <Loader />
        </Dimmer>
      )}
      <Modal.Content image scrolling>
        <Modal.Description>
          <SemanticTable size="big" celled>
            <SemanticTable.Header>
              <SemanticTable.Row>
                <SemanticTable.HeaderCell>
                  Nome do parceiro
                </SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>E-mail</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Whatsapp</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>instagram</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>blog</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>
                  Tipo de parceria
                </SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>
                  editar andamento
                </SemanticTable.HeaderCell>
              </SemanticTable.Row>
            </SemanticTable.Header>
            <SemanticTable.Body>
              <SemanticTable.Row>
                <SemanticTable.Cell>
                  {parceiroSolicitacao?.nome}
                </SemanticTable.Cell>
                <SemanticTable.Cell>
                  {parceiroSolicitacao?.email}
                </SemanticTable.Cell>
                <SemanticTable.Cell>
                  {parceiroSolicitacao?.telefone}
                </SemanticTable.Cell>
                <SemanticTable.Cell>
                  {parceiroSolicitacao?.instagram}
                </SemanticTable.Cell>
                <SemanticTable.Cell>
                  {parceiroSolicitacao?.blog}
                </SemanticTable.Cell>
                <SemanticTable.Cell>
                  {parceiroSolicitacao?.tipo === 2 ? "Influenciador" : "Blog"}
                </SemanticTable.Cell>
                <SemanticTable.Cell>
                  <select onChange={(e) => setAndamento(e.target.value)}>
                    <option value="1">Não iniciado</option>
                    <option value="2">Em andamento</option>
                    <option value="3">Finalizado</option>
                  </select>
                </SemanticTable.Cell>
              </SemanticTable.Row>
            </SemanticTable.Body>
          </SemanticTable>
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={() => setOpen(false)} color="red">
          Fechar <Icon name="x icon" />
        </Button>
        <Button onClick={saveData} color="green">
          Salvar
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default ScrollingModal;
